import UserPermissionsForm from "../../components/userPermissionsForm";
import UserPermissions from "../../components/userPermissions";
import {buildPermissionRows, isUserASuperUser, userHasSchools, userUsesSchools} from "../../utils/users";
import {buildSchoolLists, clearSchoolsLists, fetchSchoolsLists, schoolsListsRemove} from "../../actions/schools";
import {useDispatch, useSelector} from "react-redux";
import {fetchPermissionsList, saveUserPermissions, updateUserPermissions} from "../../actions/users";
import React, {useEffect, useRef, useState} from "react";
import PermissionDistrictRow from "../../components/permissionDistrictRow";
import Selector from "../../components/common/selector";
import FormRadio from "../../components/common/formRadio";

const EditUserPermissions = (props) => {
  const {
    userProfile,
    errors,
    onCancelAction,
    districts,
    userDistricts,
    userSchools,
    onSubmitPermissions,
    permissionsList
  } = props;

  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(checkForInitialDisabledState(userProfile, userDistricts, userSchools));
  const [permissionLevel, setPermissionLevel] = useState(userProfile.permission.authority);
  const [permissionType, setPermissionType] = useState('schools');
  const [permissionDistricts, setPermissionDistricts] = useState(userDistricts);
  const [permissionSchools, setPermissionSchools] = useState(userSchools);
  const [showPermissionType, setShowPermissionType] = useState(permissionLevel === 'ROLE_PERMISSION_BATCH');
  const [showDistricts, setShowDistricts] = useState(true);
  const [showSchools, setShowSchools] = useState(userUsesSchools(userProfile) && userDistricts.length > 0);
  const [addRows, setAddRows] = useState(true);
  //This holds an array of keys for the permission rows
  const [permissionsRows, setPermissionsRows] = useState(buildPermissionRows(userDistricts));

  function checkForInitialDisabledState() {
    if (userProfile.districtList && userProfile.districtList.length > 0 && userProfile.districtList[0].id) {
      return !(userDistricts && userDistricts.length > 0);
    } else if (userProfile.schoolList && userProfile.schoolList.length > 0 && userProfile.schoolList[0].id) {
      return !(userSchools && userSchools.length > 0);
    }

    return true;
  }

  const schoolListsLoaded = useRef(false);


  useEffect(() => {
    async function getAllDistrictSchoolLists() {
      if (!schoolListsLoaded.current && userSchools.length > 0) {
        schoolListsLoaded.current = true;
        await dispatch(buildSchoolLists(userDistricts));
      }
    }

    getAllDistrictSchoolLists();
  }, [permissionsList, userSchools, userDistricts, dispatch]);

  function checkToEnableSave(permissionArray) {
    return permissionsRows.length > 0 && permissionArray.length === permissionsRows.length;
  }

  const permissionLevelOnChange = async (newLevel) => {
    let submitDisabled = true;
    let showAddRows = addRows;

    setPermissionLevel(newLevel);
    switch (newLevel) {
      case 'ROLE_PERMISSION_SUPER_USER':
        showAddRows = false;
        submitDisabled = false;
        await dispatch(clearSchoolsLists());
        setShowDistricts(false);
        setShowSchools(false);
        setShowPermissionType(false);
        clearAllPermissionValues();
        break;
      case 'ROLE_PERMISSION_ADMIN':
        showAddRows = true;
        submitDisabled = !checkToEnableSave(permissionDistricts);
        setShowPermissionType(false);
        setShowSchools(false);
        setShowDistricts(true);
        clearSchoolValues();
        break;
      case 'ROLE_PERMISSION_COORDINATOR':
      case 'ROLE_PERMISSION_VIEWER':
        showAddRows = true;
        setShowPermissionType(false);
        submitDisabled = !checkToEnableSave(permissionSchools);
        if (showDistricts === false) {
          setShowDistricts(true);
        }
        if (permissionDistricts && permissionDistricts.length > 0) {
          setShowSchools(true);
          await dispatch(buildSchoolLists(permissionDistricts));
        }
        break;
      case 'ROLE_PERMISSION_BATCH':
        showAddRows = true;

        setShowPermissionType(true);

        if (showDistricts === false) {
          setShowDistricts(true);
        }

        if (permissionDistricts && permissionType === 'schools') {
          await dispatch(buildSchoolLists(permissionDistricts));
          await setShowSchools(true);
        }

        submitDisabled = !checkToEnableSave((permissionType === 'schools') ? permissionSchools : permissionDistricts);

        break;
      default:
        showAddRows = false;
        submitDisabled = true;
        await dispatch(clearSchoolsLists());
        setShowDistricts(false);
        setShowSchools(false);
        setShowPermissionType(false);
        clearDistrictValues();
        clearSchoolValues();
        setPermissionsRows([]);
        break;
    }

    if (submitDisabled !== disabled) {
      setDisabled(submitDisabled);
    }

    setAddRows(showAddRows);
  }

  const permissionTypeOnChange = (permissionType) => {
    setPermissionType(permissionType);
    switch (permissionType) {
      case 'districts':
        setShowSchools(false);
        setDisabled(permissionsRows.length !== permissionDistricts.length);
        clearSchoolValues();
        break;
      case 'schools':
        setShowSchools(true);
        setDisabled(true);
        break;
      default:
    }
  }

  const districtChange = async (newDistrict, index) => {
    let newPermissionDistricts = permissionDistricts.slice();
    let submitDisabled = true;
    let districtObject = null;
    let clearSchools = false;
    if (districts) {
      districtObject = districts.find(element => element.id === parseInt(newDistrict));
    }

    if (parseInt(newDistrict) === 0) {
      setDisabled(true);
    } else {
      if (districtObject) {
        await dispatch(fetchSchoolsLists(districtObject, index));
      }

      switch (permissionLevel) {
        case 'ROLE_PERMISSION_ADMIN':
          submitDisabled = false;
          setShowSchools(false);
          break;
        case 'ROLE_PERMISSION_COORDINATOR':
        case 'ROLE_PERMISSION_VIEWER':
          if (districtObject) {
            setShowSchools(true);
            clearSchools = true;
          }
          break;
        case 'ROLE_PERMISSION_BATCH':
          if (districtObject) {
            if (permissionType === 'schools') {
              setShowSchools(true);
              clearSchools = true;
            } else {
              submitDisabled = false;
            }
          }
          break;
        default:
          break;
      }
      if (districtObject) {
        newPermissionDistricts[index] = districtObject;
        setPermissionDistricts(newPermissionDistricts);
      }

      if (clearSchools && permissionSchools[index]) {
        schoolChange([], index);
      }

      if (submitDisabled !== disabled) {
        setDisabled(submitDisabled);
      }
    }
  }

  const schoolsLists = useSelector((state) => state.schools.schoolsLists);

  const schoolChange = (selectedSchools, districtIndex) => {
    let newPermissionSchools = permissionSchools.slice();
    let schoolObject = null;

    let schoolsToSubmit = [];

    if (!newPermissionSchools[districtIndex]) {
      newPermissionSchools[districtIndex] = [];
    }

    selectedSchools.forEach((school) => {
      schoolObject = schoolsLists[districtIndex].find(element => element.id === school.value )

      if (schoolObject) {
        schoolsToSubmit.push(schoolObject);
      }
    })

    newPermissionSchools[districtIndex] = schoolsToSubmit;


    if (schoolsToSubmit.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }

    setPermissionSchools(newPermissionSchools);
  };

  function clearAllPermissionValues() {
    clearDistrictValues();
    clearSchoolValues();
    clearPermissionRows();
  }

  function clearDistrictValues() {
    setPermissionDistricts([]);
  }

  function clearSchoolValues() {
    setPermissionSchools([]);
  }

  function clearPermissionRows() {
    setPermissionsRows([0]);
  }

  function getSchoolListFromPermissionSchools(permissionSchools) {
    return permissionSchools.flat();
  }

  const onSubmitAction = async () => {
    await setDisabled(true);
    const permissions = {
      'permissionLevel': permissionLevel
    }

    if (permissionLevel && permissionLevel !== 'ROLE_PERMISSION_SUPER_USER') {
      if (permissionLevel === 'ROLE_PERMISSION_ADMIN' || (permissionLevel === 'ROLE_PERMISSION_BATCH' && permissionType === 'districts')) {
        permissions.districts = permissionDistricts;
      } else {
        permissions.schools = await getSchoolListFromPermissionSchools(permissionSchools);
      }
    }

    await dispatch(updateUserPermissions(userProfile, permissions));
    await onSubmitPermissions();
  }

  const getSelectItems = (items, defaultLabel) => {
    const defaultItem = {id: 0, name: defaultLabel};

    if (!items) {
      return [defaultItem];
    }

    const selectItems = items;

    if (!selectItems.find((item) => item.id === 0)) {
      selectItems.unshift(defaultItem);
    }


    return selectItems;
  }

  function filterSelectedItems(items, selectedItems, index) {
    const selectItems = [];

    if (selectedItems.length === 0) {
      return items;
    }

    const currentSelectedItem = selectedItems[index];

    items.forEach((item) => {
      let showItem = true;

      selectedItems.forEach((selectedItem) => {
        if (item.id === selectedItem.id && (!currentSelectedItem || currentSelectedItem.id !== selectedItem.id)) {
          showItem = false;
        }
      })

      if (showItem === true) {
        selectItems.push(item);
      }
    });

    return selectItems;
  }

  const addAction = () => {
    const newPermissionsRows = permissionsRows.slice();
    const permissionsMax = (newPermissionsRows.length > 0) ? Math.max(...newPermissionsRows) : -1;

    newPermissionsRows.push((permissionsMax === -1 ) ? 0 : permissionsMax+1);
    setPermissionsRows(newPermissionsRows);
  }

  const removeAction = async (index) => {
    const newPermissionsRows = permissionsRows.slice();
    const newPermissionSchools = permissionSchools.slice();
    const newPermissionDistricts = permissionDistricts.slice();
    const rowToRemove = newPermissionsRows.indexOf(index);

    if (index > -1) {
      newPermissionsRows.splice(rowToRemove, 1);
      newPermissionDistricts.splice(rowToRemove, 1);
      newPermissionSchools.splice(rowToRemove, 1);

      if (newPermissionDistricts.length === 0) {
        await setDisabled(true);
      } else if (newPermissionDistricts.length === newPermissionSchools.length) {
        await setDisabled(false);
      }

      await dispatch(schoolsListsRemove(index));
      await setPermissionDistricts(newPermissionDistricts);
      await setPermissionSchools(newPermissionSchools);
      await setPermissionsRows(Array.from(newPermissionsRows.keys()));
    }
  }

  function buildPermissionLevelList() {
    const permissionsLevelList = permissionsList.map((permission) =>  {
      if (permission.authority === 'ROLE_PERMISSION_USER' || permission.authority === 'ROLE_PERMISSION_SUPER_USER') {
        return false;
      }

      return {
        label: permission.name,
        value: permission.authority
      }
    }).filter((permission) => permission !== false);

    permissionsLevelList.unshift({
      label: 'Select Permission Level',
      value: ''
    });

    return permissionsLevelList;
  }

  const districtRow = (index) => {
    return <PermissionDistrictRow
      districtIndex={index}
      districts = {filterSelectedItems(getSelectItems(districts, 'Select a District'),
        permissionDistricts,
        index)}
      schools = {(schoolsLists !== []) ? schoolsLists[index] : []}
      districtChange={districtChange}
      schoolChange={schoolChange}
      removeAction={removeAction}
      permissionDistricts={permissionDistricts}
      permissionSchools={permissionSchools}
      showDistricts={showDistricts}
      showSchools={showSchools}
      canRemoveFirstRow={true}
    />
  }

  const permissionTypeValues = [
    {
      value: 'schools',
      label: 'Schools'
    },
    {
      value: 'districts',
      label: 'Districts'
    }
  ]

  function getAddButtonLabel() {
    return permissionLevel === 'ROLE_PERMISSION_VIEWER' || permissionLevel === 'ROLE_PERMISSION_COORDINATOR' || (permissionLevel === 'ROLE_PERMISSION_BATCH' && permissionType === 'schools');
  }

  return (
    <UserPermissionsForm
      formTitle='Update Permissions'
      submitLabel='Save'
      submitAction={onSubmitAction}
      hideAddRow={!addRows || isUserASuperUser(userProfile)}
      addAction={addAction}
      disabled={disabled}
      formSubmitPosition='top'
      cancelAction={onCancelAction}
      addButtonLabel={getAddButtonLabel() ? 'Add School' : 'Add District'}
      >
      <Selector
        name="role"
        id="permissionLevel"
        label='Permission Level'
        value={permissionLevel}
        changeAction={permissionLevelOnChange}
        showLabel={true}
        items={(permissionsList) ? buildPermissionLevelList(permissionsList) : []}
      />
      <FormRadio
        name='permission-type'
        label='Assign to'
        id='permission-type'
        changeAction={permissionTypeOnChange}
        options={permissionTypeValues}
        disabled={!showPermissionType}
        hide={!showPermissionType}
        value={permissionType}
      />

      {permissionsRows.map((row) => {
        return districtRow(row);
      })}
    </UserPermissionsForm>
  );
}

export default EditUserPermissions;